export const TOKEN_STORAGE_KEY = "auth_token";
export const REFRESH_TOKEN_STORAGE_KEY = "refresh_token";
export const LANGUAGE_STORAGE_KEY = "app_language";
export const ONBOARDING_STATUS_STORAGE_KEY = "onboarding_status";
